import React from 'react'
import cn from 'classnames'
import { useDropdown } from '@hooks/useDropdown'
import { DragIndicatorIcon } from '@components/icons/DragIndicatorIcon'
import { ReportButtonProps } from './interface'

export const ReportButton = ({ reportModalHandler }: ReportButtonProps) => {
  const { dropdownRef, isShowDropdown, toggleDropdown } = useDropdown()

  return (
    <div ref={dropdownRef} className='relative'>
      <button
        type='button'
        className={cn('bg-white dark:bg-transparent px-[5px]', {
          'border-blue': isShowDropdown,
        })}
        onClick={toggleDropdown}
      >
        <div className='flex'>
          <DragIndicatorIcon
            width='20'
            height='20'
            className={cn('', {
              'text-primary': isShowDropdown,
              'text-secondary-1': !isShowDropdown,
            })}
          />
        </div>
      </button>
      <div
        className={cn(
          'absolute w-[120px] z-10 text-[14px] py-[10px] font-light text-secondary dark:text-dark-10 right-0 bg-white dark:bg-dark-9 rounded-[8px] shadow',
          { hidden: !isShowDropdown }
        )}
      >
        <div
          onClick={() => {
            toggleDropdown()
            reportModalHandler()
          }}
          className='px-[15px] py-[5px] hover:bg-blue-2 dark:hover:bg-dark cursor-pointer hover:text-primary dark:hover:text-dark-10'
        >
          รายงานเนื้อหา
        </div>
      </div>
    </div>
  )
}
